import moment from 'moment';
import * as React from 'react';

import { Link } from 'react-router-dom';

import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';
import analytics from '../../../shared/services/analytics/analytics';
import FlashMessages from '../../FlashMessages/FlashMessages';
import { FooterAlphasDetails } from '../AlphaFooter/AlphaFooter';

import './AlphasDetails.scss';
import AlphasDetailsContent from './Content/AlphasDetailsContent';
import HeaderAlphasDetails from './HeaderAlphasDetails';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface AlphasDetailsProps {
  handleHide: () => void;
  active: boolean;
  activeAlphaInfo: any;
  handleVisualization: (id: string) => void;
  handleFavorite: (id: string) => void;
  handleSubmitAlpha: () => void;
  handleCheckSubmission: () => void;
  isAlphaCreatedByTheCurrentUser: boolean;
  isConsultant: boolean;
  alphaStatus: string;
  fetchingCheck: boolean;
  openModalCloseProperties: boolean;
  handleCancelCloseAlphaProperties: () => void;
  handleNotSaveCloseAlphaProperties: () => void;
  headerHeight: number;
  flashMessages?: any;
  handlerShowDetail: (alphaDetail: string) => void;
  nextAlphaDetail: string;
  hasErrors: boolean;
  isTestPeriodShown: boolean;
  isTestPeriodControlShown: boolean;
}

const getAlphaDate = (activeAlphaInfo: any) => moment(activeAlphaInfo.get('dateCreated')).tz('America/New_York').format('L z');

export class AlphasDetails extends React.Component<AlphasDetailsProps> {
  componentDidUpdate(prevProps: AlphasDetailsProps) {
    if (
      (prevProps.flashMessages && !prevProps.flashMessages.equals(this.props.flashMessages)) ||
      (prevProps.flashMessages === undefined && this.props.flashMessages)
    ) {
      const elemScroll: any = document.querySelector('.alphas-details__data');
      const footer: any =
        document.querySelector('.alphas__footer-messages') && typeof this.props.activeAlphaInfo?.get('author') === 'string';
      if (elemScroll && footer) {
        const footerHeight: number = footer ? footer.clientHeight : 0;
        // 122 represent the top bar plus the settings
        elemScroll.style.height = `calc(100vh - ${footerHeight + 122}px)`;
      }
    }
  }

  onFavoriteClick = () => this.props.handleFavorite(this.props.activeAlphaInfo.get('id'));

  onVisibilityClick = () => {
    analytics.trackCustomEvent('alphas_click_hide', { event_label: 'detail' });
    this.props.handleVisualization(this.props.activeAlphaInfo.get('id'));
  };

  getAlphaNameAndDate = () => {
    const { activeAlphaInfo } = this.props;
    let dateCreated: string = '';
    let alphaName: string = '';
    let hasFailedChecks = false;
    if (activeAlphaInfo) {
      dateCreated = getAlphaDate(activeAlphaInfo);
      alphaName = activeAlphaInfo.get('name') ? activeAlphaInfo.get('name') : 'anonymous';
      if (activeAlphaInfo.getIn(['is', 'checks'])) {
        hasFailedChecks = activeAlphaInfo.getIn(['is', 'checks']).filter((check: any) => check.get('result') === 'FAIL').size > 0;
      }
    }
    const stage = activeAlphaInfo.get('os') !== null ? 'os' : 'is';
    const status = activeAlphaInfo.get('status');

    return { dateCreated, alphaName, hasFailedChecks, stage, status };
  };

  render() {
    const {
      handleHide,
      active,
      activeAlphaInfo,
      handleSubmitAlpha,
      handleCheckSubmission,
      isAlphaCreatedByTheCurrentUser,
      isConsultant,
      isTestPeriodShown,
      isTestPeriodControlShown,
      alphaStatus,
      fetchingCheck,
      openModalCloseProperties,
      handleCancelCloseAlphaProperties,
      handleNotSaveCloseAlphaProperties,
      headerHeight,
      handlerShowDetail,
      nextAlphaDetail,
      hasErrors,
    } = this.props;
    const modifiers = active === true ? ['active'] : [];
    const { dateCreated, alphaName, hasFailedChecks, stage, status } = this.getAlphaNameAndDate();

    const isOthersAlpha = typeof activeAlphaInfo.get('author') !== 'string';
    return (
      <div className={addModifiers('alphas-details', modifiers)}>
        <div className="alphas-details__overlay" />
        <div
          className={addModifiers('alphas-details__container', modifiers)}
          style={{ top: `${headerHeight}px`, height: `calc(100% - ${headerHeight}px)` }}
        >
          <div className="alphas-details-content">
            <HeaderAlphasDetails
              dateCreated={dateCreated}
              activeAlphaInfo={activeAlphaInfo}
              onFavoriteClick={this.onFavoriteClick}
              onVisibilityClick={this.onVisibilityClick}
              handleHide={handleHide}
              alphaName={alphaName}
              stage={stage}
              status={status}
              isConsultant={isConsultant}
              openModalCloseProperties={openModalCloseProperties}
              handleCancelCloseAlphaProperties={handleCancelCloseAlphaProperties}
              handleNotSaveCloseAlphaProperties={handleNotSaveCloseAlphaProperties}
              handlerShowDetail={handlerShowDetail}
              nextAlphaDetail={nextAlphaDetail}
              isOthers={isOthersAlpha}
            />
            <Link
              className="alphas-details-content__link-lg"
              to={`/alpha/${activeAlphaInfo.get('id')}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessageHelper
                tagName="span"
                id="alphasDetails.openAlphaDetails"
                defaultMessage={localeData.en['alphasDetails.openAlphaDetails']}
              />
            </Link>
            {activeAlphaInfo !== null && (
              <AlphasDetailsContent
                path={['alphas']}
                showAlphaCode={true}
                itemsStoredName="alphas-details-order"
                showCode={false}
                showLearn={false}
                isSimulation={false}
                shouldResize={false}
                isOthers={isOthersAlpha}
              />
            )}
            {!isOthersAlpha && (
              <div className="alphas__footer-messages">
                <div id="alphas-details-content__content" className="alphas__message">
                  <FlashMessages location="alpha-details" />
                </div>

                <FooterAlphasDetails
                  isTestPeriodShown={isTestPeriodShown}
                  isTestPeriodControlShown={isTestPeriodControlShown}
                  handleCheckSubmission={handleCheckSubmission}
                  alphaStatus={alphaStatus}
                  handleSubmitAlpha={handleSubmitAlpha}
                  fetchingCheck={fetchingCheck}
                  hasFailedChecks={activeAlphaInfo && activeAlphaInfo.getIn(['is', 'checks']) ? hasFailedChecks : false}
                  hasErrors={hasErrors}
                  isAlphaCreatedByTheCurrentUser={isAlphaCreatedByTheCurrentUser}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
